// removed by extract-text-webpack-plugin
module.exports = {"header":"style__header__3lAs0","shopImage":"style__shopImage__25w1q","sidebarProfile":"style__sidebarProfile__1bVbv","sidebarTitle":"style__sidebarTitle__2dvTI","FooterWrap":"style__FooterWrap__2JIWZ","sidebarUser":"style__sidebarUser___1xBF","ant-menu-item":"style__ant-menu-item__lkvRi","ant-menu-inline":"style__ant-menu-inline__2HZJ7","logo":"style__logo__1icC3","trigger":"style__trigger__1baxL","right":"style__right__Xbq8Q","action":"style__action__2pfOn","search":"style__search__3yBMJ","account":"style__account__89fNQ","avatar":"style__avatar__3xWi9","menu":"style__menu__3hXdj","sider":"style__sider__2jvIM"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/style.less
// module id = 1366
// module chunks = 0